import { useEffect } from 'react';
import { useSubNav } from '../contexts/SubNavContext';
import './Chat.css';

export default function Chat() {
    const { setSubNav } = useSubNav();

    useEffect(() => {
        setSubNav([
            { 
                href: '#mark1', 
                label: '챗봇', 
                active: true,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark1');
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
        ]);
        return () => setSubNav(null);
    }, [setSubNav]);

    const openPopup = (url, name) => {
        const features = 'width=1200,height=800,top=100,left=100,resizable=no,scrollbars=yes';
        window.open(url, name, features);
    };

    return (
        <>
            <div className="container chat-container">
                <div className="cont_visual business">
                    <h2>플레이봇</h2>
                    <p>
                        일과 조직 문화를 손쉽게 확인할 수 있는 사내 챗봇으로, <br />
                        장소나 시간에 상관없이 세 가지 캐릭터 중 원하는 스타일을 선택해 사용할 수 있습니다.
                    </p>
                </div>

                <div className="cont wrap_cont">
                    <div className="cont_p" id="mark1">
                        <ul className="cont_chat">
                            <li className="bot01">
                                <button onClick={() => openPopup('https://www.yncsmart.com/dollkongbot/', 'dolkong')}>
                                    <span>Chatbot</span>
                                    <span className="ver">돌콩봇</span>
                                </button>
                            </li>
                            <li className="bot02">
                                <button onClick={() => openPopup('https://www.yncsmart.com/bhdbot/', 'bhdbot')}>
                                    <span>Chatbot</span>
                                    <span className="ver">배홍동</span>
                                </button>
                            </li>
                            <li className="bot03">
                                <button onClick={() => openPopup('https://www.yncsmart.com/nyongbot/', 'nyongbot')}>
                                    <span>Chatbot</span>
                                    <span className="ver">뇽챗</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
